import "core-js/modules/es7.string.pad-start.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
export var getHexOpacityFromPercentage = function getHexOpacityFromPercentage(number) {
  return Math.floor(number / 100 * 255).toString(16).padStart(2, '0');
};
export var generateOpacityHex = function generateOpacityHex(hex, opacity) {
  var hexCode = (hex === null || hex === void 0 ? void 0 : hex.slice(0, 7)) || '';
  var hexOpacity = getHexOpacityFromPercentage(opacity);
  return [hexCode, hexOpacity].join('');
};